import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import images from './assets/images'
import bannerBox from './components/banner-box'
import zTitle from './components/z-title'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.config.productionTip = false
Vue.prototype.$images = images
Vue.component('bannerBox', bannerBox)
Vue.component('zTitle', zTitle)
Vue.prototype.$EventBus = new Vue()
Vue.use(ElementUI)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
